module.exports = __webpack_public_path__ + "img/icon3.6a0388f7.png";